// **BEGIN** Hextom TMS Integration - DO NOT MODIFY
      var hextom_tms = {
        selectorInsertType:  "insert",
        regionType:  "region_name_currency_symbol",
        availableLocalesById: {},
        availableLocales: [],
        primaryLocaleById: {},
        merchantSelectedLocale: "shop_base",
        hasFlag: "no",
        selectorFlagMap: {'en': 'en', 'nl': 'nl'},
        displayType: "language_code",
        fontColor: "#000000",
        backgroundColor: "#FFFFFF",
        backgroundOpacity: "0.0",
        buttonFontColor: "#FFFFFF",
        buttonBackgroundColor: "#000000",
        selectorType: "market_language",
        selectorStyle: "dropdown",
        hasFlagRegion: "yes",
        defaultRegion: "ip_base",
        primaryRegionById: {},
        availableRegionsByCode: {},
        availableRegions: [],
        primaryDomain: "",
        popupEnable: false,
        popupTextColor: "#000000",
        popupBgColor: "#FFFFFF",
        popupBtnTextColor: "#FFFFFF",
        popupBtnBgColor: "#000000",
        regions: [{"name": "Netherlands", "code": "NL", "currency": {"code": "EUR", "symbol": "\u20ac"}, "languages": {"English": {"name": "English", "native_name": "English", "code": "en", "default": true}, "Nederlands": {"name": "Nederlands (Dutch)", "native_name": "Nederlands", "code": "nl", "default": false}}, "primary": true}],
      };
    // **END** Hextom TMS Integration - DO NOT MODIFY
        